import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useResErrors } from 'hooks'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { EyeIcon, EyeOffIcon, FutureIconContainer } from 'asterX-UI/Icons'
import KeyIcon from 'asterX-UI/Icons/KeyIcon'
import {
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Button
} from '@material-ui/core'
import { AuthService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import generator from 'generate-password'

const ChangePasswordModal = ({
  open = false,
  username,
  onClose = () => {}
}) => {
  const { t } = useTranslation()
  const namespace = 'profilePage.profileFields.changePasswordModal.'
  const { standardCheck } = useResErrors()
  const [showPass, setShowPass] = useState(false)
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const generatePass = () => {
    const pswd = generator.generate({
      length: 6,
      numbers: true,
      strict: true
    })
    setPassword(pswd)
  }

  const onChange = e => setPassword(e.target.value)

  const handleSave = async () => {
    setLoading(true)
    await AuthService.changeUserPassword(username, password).then(res =>
      standardCheck(
        res,
        () => {
          setLoading(false)
          onClose()
        },
        {
          textErr: t(namespace + 'errors.default'),
          onFail: () => setLoading(false)
        }
      )
    )
  }

  return (
    <ActionModal
      open={open}
      color={'primary'}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleSave}
      iconComponent={
        <FutureIconContainer color={'primary'}>
          <KeyIcon />
        </FutureIconContainer>
      }
      title={t(namespace + 'title')}
      labelConfirm={t(namespace + 'save')}
    >
      <Grid container spacing={2}>
        <LoaderBackdrop loading={loading} />
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <TextField
            name={'password'}
            value={password || ''}
            onChange={onChange}
            label={t(namespace + 'writeNewPass')}
            autoComplete="off"
            type={showPass ? 'text' : 'password'}
            fullWidth
            required
            InputProps={{
              autoComplete: 'new-password',
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPass(!showPass)}
                    onMouseDown={event => event.preventDefault()}
                    edge="start"
                  >
                    {showPass ? <EyeIcon /> : <EyeOffIcon />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Button
            fullWidth
            variant={'contained'}
            onClick={() => generatePass()}
          >
            {t(namespace + 'generatePassword')}
          </Button>
        </Grid>
      </Grid>
    </ActionModal>
  )
}
export default ChangePasswordModal
